<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="$check(user, ['users.update'])" type="button" elevation="0" color="primary"
                            @click=updateUser()>Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/credores">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row v-if="dataset.data.account_verified_at === '0000-00-00 00:00:00'">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>
                    Este credor ainda não verificou o cadastro

                    <template v-slot:actions>
                        <v-btn :disabled="!($check(user, ['users.verify']))" color="primary" text
                            @click="verifyAccount()">
                            VERIFICAR AGORA
                        </v-btn>
                    </template>
                </v-banner>
            </v-col>
        </v-row>
        <v-row v-if="dataset.data.account_approved_at !== '0000-00-00 00:00:00' && dataset.data.type === 1">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="accent" size="36">
                        mdi-check-circle-outline
                    </v-icon>
                    Este credor está incluso na lista de credores
                </v-banner>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes
                                    <v-spacer></v-spacer>

                                    <div class="icon-toolbar">
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="dialogAddress = true" size="x-large" color="primary">
                                                    mdi-card-account-details-outline
                                                </v-icon>
                                            </template>
                                            <span>Visualizar dados cadastrais do credor</span>
                                        </v-tooltip>
                                    </div>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense id="name" label="Nome completo"
                                                v-model="dataset.data.name" required :rules="[$rules.required]" outlined
                                                hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['users.update']))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="E-mail" v-model="dataset.data.email" required
                                                outlined hide-details="auto"
                                                :disabled="dataset.data.type === 3 || (!page.isNew && (!$check(user, ['users.update'])))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="Telefone" v-model="dataset.data.phone_number"
                                                outlined hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['users.update']))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field disabled dense id="registration"
                                                :label="dataset.data.is_foreign ? 'Identificação' : 'CPF/CNPJ'"
                                                v-model="dataset.data.registration" required
                                                @input="dataset.data.is_foreign ? null : formatRegistration()"
                                                :rules="[$rules.required, dataset.data.is_foreign ? null : (dataset.data.registration && dataset.data.registration.length < 15 ? $rules.cpf : $rules.cnpj)]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="!page.isNew && $check(user, ['users.update.tempestive'])">
                                        <v-col cols="12" sm="12">
                                            <v-checkbox v-model="checkIfTempestiva" :label="`Tempestiva`"
                                                @change="handleTempestivaChange"
                                                :disabled="!page.isNew && (!$check(user, ['users.update.tempestive']))"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" class="mt-n10">
                                            <v-checkbox v-model="dataset.data.invalid_doc_id"
                                                :label="'Documento de ID inválido'"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-row
                                    v-if="dataset && dataset.data && Array.isArray(dataset.data.representatives) && dataset.data.representatives.length > 0"
                                    text-align="center">
                                    <v-col class="mb-n5" cols="12" v-for="(rep, index) in dataset.data.representatives"
                                        :key="rep.id || index">
                                        <v-card class="card-form-outlined">

                                            <v-card-title class="card-group-title">
                                                <div class="title-container">
                                                    <div class="title-block">
                                                        <span class="table-card-title">
                                                            Representante - {{ index + 1 }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </v-card-title>

                                            <v-card-text>
                                                <v-sheet class="pa-4" elevation="0"
                                                    style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px;">

                                                    <v-row>
                                                        <v-col cols="12" sm="8">
                                                            <v-text-field label="Nome representante" :value="rep.name"
                                                                disabled dense outlined />
                                                        </v-col>

                                                        <v-col cols="12" sm="4">
                                                            <v-text-field label="CPF representante"
                                                                :value=formatRepRegistration(rep) disabled dense
                                                                outlined />
                                                        </v-col>
                                                    </v-row>

                                                    <v-row align="center" justify="space-between" class="mt-n10">
                                                        <v-col cols="8">
                                                            <v-alert dense colored-border border="left" elevation="0"
                                                                variant="outlined" prominent
                                                                :type="getRepStatusColor(rep.status)">
                                                                {{ getRepStatusText(rep.status) }}
                                                            </v-alert>
                                                        </v-col>

                                                        <!-- Ações -->
                                                        <v-col cols="4" class="d-flex justify-end">
                                                            <v-btn small color="success" class="mr-2"
                                                                :disabled="rep.status === 1"
                                                                @click="changeRepresentativeStatus(rep.id, 1)">
                                                                Aprovar
                                                            </v-btn>

                                                            <v-btn small color="error" :disabled="rep.status === 2"
                                                                @click="changeRepresentativeStatus(rep.id, 2)">
                                                                Rejeitar
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>

                                                    <!-- Documento -->
                                                    <v-row class="mt-n2">
                                                        <v-col cols="3">
                                                            <v-btn color="primary" outlined :href="rep.documentUrl"
                                                                target="_blank">
                                                                Visualizar documento
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row class="mt-1">
                                                        <v-col cols="6">
                                                            <iframe :src="rep.documentUrl" width="250" height="150"
                                                                frameborder="0" scrolling="no"
                                                                class="rounded-xl"></iframe>
                                                            <div class="caption-text">DOCUMENTO REPRESENTANTE</div>
                                                        </v-col>
                                                    </v-row>

                                                </v-sheet>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>


                                <!-- <v-row v-if="dataset.data && dataset.data.representative_registration && (!dataset.data.representatives || (dataset.data.representatives && !dataset.data.representatives.length))" text-align="center">

                                    <v-col cols="12">
                                        <v-card class="card-form-outlined">
                                            
                                            <v-card-title class="card-group-title">
                                                <div class="title-container">
                                                    <div class="title-block">
                                                        <span id="title" class="table-card-title">Representante</span>
                                                    </div>
                                                </div>
                                            </v-card-title>
                                        
                                          <v-card-text>
                                            <template v-if="dataset.data">
                                              
                                                <v-sheet
                                                    class="pa-4"
                                                    elevation="0"
                                                    style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px;"
                                                    >

                                                    <v-row class="mt-1">
                                                        <v-col cols="12" sm="8">
                                                            <v-text-field
                                                            label="Nome representante"
                                                            :value="dataset.data.representative_name"
                                                            disabled
                                                            dense
                                                            outlined
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="4">
                                                            <v-text-field
                                                            :label="dataset.data.is_foreign ? 'Identificação representante' : 'CPF/CNPJ representante'"
                                                            :value="formattedRepresentativeRegistration"
                                                            disabled
                                                            dense
                                                            outlined
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                
                                                    <v-row class="mt-n5" align="center" justify="space-between">
                                                    
                                                        <v-col cols="8">
                                                            <v-alert
                                                                dense colored-border border="left" elevation="0" variant="outlined" prominent
                                                                :type="getRepStatusColor(dataset.data.representative_status)"
                                                            >
                                                            <div class="d-flex align-center">
                                                                <span>{{ getRepStatusText(dataset.data.representative_status) }}</span>
                                                                <template v-if="dataset.data.representative_status === 2 && shortRejectReason">
                                                                
                                                                    <v-btn
                                                                        text small class="ml-2"
                                                                        @click="showRejectReasonModal = true"
                                                                    >
                                                                        Ver motivo
                                                                    </v-btn>
                                                                </template>
                                                            </div>
                                                            </v-alert>
                                                        </v-col>
                                            
                                                        <v-col cols="4" class="d-flex justify-end">
                                                            <v-tooltip bottom>
                                                                <template #activator="{ on, attrs }">
                                                                    <v-btn
                                                                        small color="success" class="mr-2"
                                                                        :disabled="dataset.data.representative_status === 1 || !dataset.data.representative_registration"
                                                                        @click="changeRepresentativeStatus(-1, 1)"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    >
                                                                        Aprovar
                                                                    </v-btn>
                                                                </template>
                                                                <span>Aprovar o representante</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template #activator="{ on, attrs }">
                                                                    <v-btn
                                                                        small
                                                                        color="error"
                                                                        :disabled="dataset.data.representative_status === 2 || !dataset.data.representative_registration"
                                                                        @click="changeRepresentativeStatus(-1, 2)"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    >
                                                                        Rejeitar
                                                                    </v-btn>
                                                                </template>
                                                                <span>Rejeitar o representante</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                  
                                                    <v-row class="mt-3">
                                                        <v-col cols="3">
                                                            <v-btn
                                                                type="button" elevation="0" color="primary" outlined
                                                                :href="dataset.data.representativeDocUrl"
                                                                target="_blank"
                                                                >
                                                                Visualizar documento
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="mt-3">
                                                        <v-col cols="3">
                                                          <iframe
                                                            :src="dataset.data.representativeDocUrl"
                                                            width="250"
                                                            height="150"
                                                            frameborder="0"
                                                            scrolling="no"
                                                            class="rounded-xl"
                                                          ></iframe>
                                                          <div class="caption-text">DOCUMENTO REPRESENTANTE</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-sheet>
                                            </template>
                                            <template v-else>
                                              <v-row>
                                                <v-col cols="12" class="text-center">
                                                  <span class="main-text">
                                                    Nenhum representante vinculado a este credor.
                                                  </span>
                                                </v-col>
                                              </v-row>
                                            </template>
                                          </v-card-text>
                                        </v-card>
                                    </v-col>

                                </v-row> -->

                                <v-row class="mt-n5" text-align="center" v-if="$check(user, ['users.view.lawyer'])">
                                    <v-col cols="12">
                                        <v-card class="card-form-outlined">
                                            <div class="title-container">
                                                <div class="title-block">
                                                    <v-card-title class="card-group-title">Procurador</v-card-title>
                                                </div>
                                                <div v-if="userLawyerData && userLawyerData.lawyer"
                                                    class="button-group">
                                                    <v-btn type="button" elevation="0" color="primary"
                                                        @click=lawyerDetails(userLawyerData.lawyer)>Ver detalhes</v-btn>
                                                </div>
                                            </div>
                                            <v-card-text>
                                                <template v-if="userLawyerData && userLawyerData.lawyer">
                                                    <v-row>
                                                        <v-col cols="12" sm="4">
                                                            <span class="main-text">{{ userLawyerData.lawyer.name ||
                                                                'N/A' }}</span>
                                                            <div class="caption-text2">NOME DO PROCURADOR</div>
                                                        </v-col>
                                                        <v-col cols="12" sm="4">
                                                            <span class="main-text">{{
                                                                formatCpfCnpj(userLawyerData.lawyer.registration) ||
                                                                'N/A' }}</span>
                                                            <div class="caption-text2">CPF</div>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="4">
                                                            <span class="main-text">{{
                                                                userLawyerData.lawyer.federal_registration || 'N/A' }}
                                                            </span>
                                                            <div class="caption-text2">NÚMERO OAB</div>
                                                        </v-col>
                                                        <v-col cols="12" sm="4">
                                                            <span class="main-text">{{
                                                                userLawyerData.lawyer.federal_registration_uf || 'N/A'
                                                                }}</span>
                                                            <div class="caption-text2">OAB UF</div>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="4">
                                                            <span class="main-text">{{ userLawyerData.lawyer.email ||
                                                                'Nome não disponível' }}</span>
                                                            <div class="caption-text2">E-MAIL</div>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="3">
                                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                                :href="userLawyerData.lawyer.documentUrl"
                                                                target="_blank">
                                                                Visualizar documento
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                                :href="userLawyerData.documentUrl" target="_blank">
                                                                Visualizar documento
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="3">
                                                            <iframe :src="userLawyerData.lawyer.documentUrl" width="250"
                                                                height="150" frameborder="0" scrolling="no"
                                                                class="rounded-xl"></iframe>
                                                            <div class="caption-text">DOCUMENTO OAB</div>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <iframe :src="userLawyerData.documentUrl" width="250"
                                                                height="150" frameborder="0" scrolling="no"
                                                                class="rounded-xl"></iframe>
                                                            <div class="caption-text">DOCUMENTO PROCURAÇÃO</div>
                                                        </v-col>
                                                    </v-row>

                                                </template>
                                                <template v-else>
                                                    <v-row>
                                                        <v-col cols="12" text-align="center">
                                                            <span class="main-text">Nenhum procurador
                                                                vinculado a este credor.</span>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                            </v-card-text>

                                            <v-card-text>
                                                <v-row v-if="dataset.data.type">
                                                    <v-col cols="12" sm="4">
                                                        <span class="text-uppercase font-weight-bold primary--text"
                                                            color="primary">TIPO
                                                            DE CREDOR: </span>{{ dataset.data.type |
                                                        enum(dataset.userTypes, "id",
                                                        "name") }}
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span class="table-card-title">Downloads de certidão</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table dense :headers="certificateDownloads.headers" :items="certificateDownloads.items"
                            :loading="certificateDownloads.loading" :disable-sort="true"
                            no-data-text="Nenhum download de certidão encontrado">
                            <template v-slot:[`item.downloaded_by_type`]="{ item }">
                                {{ item.downloaded_by_type | enum(certificateDownloads.actorTypes, "id", "name") }}
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | formatDate }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Lista de Procuradores -->
        <v-row v-if="procuratorsList && procuratorsList.length > 0">
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <div class="title-container d-flex justify-space-between align-center">
                        <v-card-title class="card-group-title">Procuradores</v-card-title>
                    </div>
                    <v-expansion-panels accordion>
                        <v-expansion-panel v-for="(procurator, index) in procuratorsList" :key="procurator.localId"
                            class="procurator-panel">
                            <v-expansion-panel-header>
                                <div class="d-flex align-center justify-space-between w-100">
                                    <span><strong>Procurador #{{ index + 1 }}: </strong> {{ procurator.name || 'Sem Nome' }}</span>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Nome Completo" readonly v-model="procurator.name"
                                            outlined hide-details="auto" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="OAB" readonly v-model="procurator.oab" outlined
                                            hide-details="auto" />
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Documentos</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mb-4">
                            <v-col>
                                <!-- <v-btn type="button" elevation="0" color="primary" outlined
                                    :href="dataset.data.documentUrl" target="_blank">Visualizar
                                    contrato social
                                </v-btn> adicionar v-if do social_contract -->
                                <!-- <v-btn type="button" elevation="0"
                                    :color="dataset.data.status === 0 ? 'error' : 'accent'" @click=blockUser()
                                    :disabled="!($check(user, ['users.update.access']))">
                                    {{ dataset.data.status === 0 ? 'Bloquear Acesso' : 'Desbloquear Acesso' }}
                                </v-btn> -->
                                <v-btn
                                    v-if="dataset.data.creditorData && dataset.data.creditorData.approved_amount_at !== '0000-00-00 00:00:00'"
                                    type="button" elevation="0" color="primary" dark class="mr-5"
                                    @click="restoreApprovedValue()"
                                    :disabled="!($check(user, ['users.update.approvedamount']))">Restaurar Valor
                                    Aprovado</v-btn>

                                <v-btn type="button" elevation="0" color="#7E55AB" class=" white--text"
                                    :disabled="!(dataset.data.userEvents && dataset.data.userEvents.length > 0)"
                                    @click.stop="openRequestDoc()">Solicitar Documento
                                </v-btn>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-row>
                                    <v-col cols="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="dataset.data.documentUrl" target="_blank">Visualizar
                                            documento
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-4">
                                    <v-col cols="12">
                                        <v-file-input dense
                                            accept="image/png, image/jpeg, application/pdf, .csv, application/vnd.ms-excel"
                                            prepend-icon="" outlined counter required show-size :rules="fileRules"
                                            hint="Tamanho máximo 15MB" hide-details="auto" label="Trocar documento"
                                            :clearable="true" @change="onFileSelected($event)" ref="logoFile"
                                            truncate-length="70" :disabled="!($check(user, ['users.update.files']))">
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n3">
                                    <v-col>
                                        <iframe :src="dataset.data.documentUrl" width="250" height="150" frameborder="0"
                                            scrolling="no" class="rounded-xl"></iframe>
                                        <div class="caption-text">DOCUMENTO</div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col v-if="dataset.data.contractUrl" cols="12" sm="2">
                                <v-row>
                                    <v-col cols="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="dataset.data.contractUrl" target="_blank">Visualizar
                                            contrato
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="11">
                                        <v-file-input dense
                                            accept="image/png, image/jpeg, application/pdf, .csv, application/vnd.ms-excel"
                                            prepend-icon="" outlined counter required show-size :rules="fileRules"
                                            hint="O arquivo não pode ser superior a 150MB" hide-details="auto"
                                            label="Trocar contrato" :clearable="true"
                                            @change="onContractSelected($event)" ref="logoFile" truncate-length="70"
                                            :disabled="!($check(user, ['users.update.files']))">
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n3">
                                    <v-col>
                                        <iframe :src="dataset.data.contractUrl" width="250" height="150" frameborder="0"
                                            scrolling="no" class="rounded-xl"></iframe>
                                        <div class="caption-text">CONTRATO SOCIAL</div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Outros Documentos</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>

                        <v-row>
                            <v-col v-for="(item, index) in dataset.data.otherDocuments" cols="12" sm="4" :key="index">
                                <v-row>
                                    <v-col cols="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="item.url" target="_blank">Visualizar
                                            documento
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n3">
                                    <v-col>
                                        <iframe :src="item.url" width="250" height="150" frameborder="0"
                                            scrolling="no" class="rounded-xl"></iframe>
                                        <div class="caption-text">DOCUMENTO #{{ index + 1 }} <i>({{ item.name }})</i></div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data && dataset.data.userEvents && dataset.data.userEvents.length > 0">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Documentos solicitados</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text v-for="(item, index) in getRequestDoc()" :key="index">
                                <v-row v-for="(doc, indexDoc) in item.docs" :key="indexDoc">
                                    <v-col v-if="doc">
                                        <span v-if="item.user_event_item_id" class="primary--text" color="primary">
                                            - <strong>Negócio #{{ item.user_event_item_id }}: </strong>
                                            <template v-if="doc.id != 50">
                                                {{ doc.id | enum(businessDocTypes, 'id', 'name') }}
                                            </template>
                                            <template v-else>
                                                {{ doc.customName || doc.name }}
                                            </template>
                                        </span>
                                        <span v-else-if="doc.id != 3" class="primary--text" color="primary">
                                            - {{ doc.id | enum(creditorEmailDocTypes, 'id', 'name') }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['users.view.logs'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Movimentações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text v-for="(item, index) in dataset.events" :key="index">
                        <v-row>
                            <v-col>
                                <span class="text-uppercase font-weight-bold primary--text" color="primary">{{
                                    getTitleByTypeEvent(item) }}:</span> {{ getMessageByTypeEvent(item) }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="!dataset.events.length">
                        <v-row>
                            <v-col cols="12">
                                Nenhuma movimentação encontrada
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- ============================================ -->
        <!-- BLOCO QGC CONSOLIDADO -->
        <!-- ============================================ -->
        <v-row class="mt-4">
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">
                        Movimentações QGC
                        <v-spacer />
                        <v-chip v-if="qgcData.loading" small color="grey" label text-color="white">
                            <v-progress-circular indeterminate size="14" width="2" class="mr-2" color="white" />
                            Carregando...
                        </v-chip>
                        <template v-else-if="qgcData.status === 'found'">
                            <v-chip v-if="qgcData.records.length > 0" small color="success" label text-color="white" class="mr-2">
                                <v-icon x-small left>mdi-check-circle</v-icon>
                                {{ qgcData.records.length }} {{ qgcData.records.length === 1 ? 'registro ativo' : 'registros ativos' }}
                            </v-chip>
                            <v-chip v-if="qgcData.removedRecords.length > 0" small color="error" label text-color="white">
                                <v-icon x-small left>mdi-close-circle</v-icon>
                                {{ qgcData.removedRecords.length }} {{ qgcData.removedRecords.length === 1 ? 'removido' : 'removidos' }}
                            </v-chip>
                        </template>
                        <v-chip v-else small color="grey" label text-color="white">
                            <v-icon x-small left>mdi-alert-circle-outline</v-icon>
                            Nao consta
                        </v-chip>
                    </v-card-title>

                    <v-card-text>

                        <!-- Loading -->
                        <v-row v-if="qgcData.loading">
                            <v-col cols="12" class="text-center py-6">
                                <v-progress-circular indeterminate color="primary" size="40" />
                                <p class="mt-2 grey--text">Consultando dados no QGC Consolidado...</p>
                            </v-col>
                        </v-row>

                        <!-- NÃO ENCONTRADO -->
                        <template v-if="!qgcData.loading && qgcData.status === 'not_found'">
                            <v-row>
                                <v-col cols="12">
                                    <v-alert type="info" text prominent border="left" class="mb-0">
                                        <div class="font-weight-bold mb-1">Credor nao localizado no QGC Consolidado</div>
                                        <div>Este credor nao esta incluido no Quadro Geral de Credores Consolidado.</div>
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- REGISTROS ATIVOS -->
                        <template v-if="!qgcData.loading && qgcData.records.length > 0">
                            <v-row>
                                <v-col cols="12">
                                    <div class="subtitle-2 font-weight-bold mb-n3" style="color: #333;">
                                        <v-icon small class="mr-1">mdi-account-details-outline</v-icon>
                                        {{ qgcData.records.length === 1 ? 'Registro ativo' : 'Registros ativos' }}
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row v-for="(record, idx) in qgcData.records" :key="'active-' + idx" class="mb-4">
                                <v-col cols="12">
                                    <v-sheet class="pa-4" elevation="0" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; border-left: 4px solid #4caf50;">
                                        <div v-if="qgcData.records.length > 1" class="mb-3">
                                            <v-chip small color="primary" label text-color="white">
                                                Registro {{ idx + 1 }} de {{ qgcData.records.length }}
                                            </v-chip>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <span class="main-text">{{ record.name || 'N/A' }}</span>
                                                <div class="caption-text2">NOME</div>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <span class="main-text">{{ formatQgcRegistration(record.registration) }}</span>
                                                <div class="caption-text2">CPF/CNPJ</div>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <span class="main-text">{{ formatQgcCreditorType(record.type) }}</span>
                                                <div class="caption-text2">CLASSE</div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <span class="main-text">R$ {{ formatQgcCurrency(record.amount) }}</span>
                                                <div class="caption-text2">VALOR DO CREDITO</div>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <span class="main-text">{{ formatQgcCurrencyType(record.currency) }}</span>
                                                <div class="caption-text2">MOEDA</div>
                                            </v-col>
                                            <!-- <v-col cols="12" sm="4">
                                                <span class="main-text">{{ formatQgcVersion(record.version) }}</span>
                                                <div class="caption-text2">VERSAO QGC</div>
                                            </v-col> -->
                                        </v-row>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- REGISTROS REMOVIDOS -->
                        <template v-if="!qgcData.loading && qgcData.removedRecords.length > 0">
                            <v-row class="mt-2">
                                <v-col cols="12">
                                    <div class="subtitle-2 font-weight-bold mb-n4" style="color: #333;">
                                        <v-icon small class="mr-1" color="error">mdi-delete-outline</v-icon>
                                        {{ qgcData.removedRecords.length === 1 ? 'Registro removido' : 'Registros removidos' }}
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row v-for="(removed, idx) in qgcData.removedRecords" :key="'removed-' + idx" class="mb-1">
                                <v-col cols="12">
                                    <v-sheet class="pa-0" elevation="1" style="border-radius: 8px; overflow: hidden;">
                                        <!-- Barra superior vermelha -->
                                        <div style="background: #f44336; padding: 10px 20px; display: flex; align-items: center; justify-content: space-between;">
                                            <div class="d-flex align-center">
                                                <v-icon color="white" class="mr-3">mdi-delete-alert-outline</v-icon>
                                                <span style="color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.5px;">
                                                    REMOVIDO — {{ formatQgcCreditorType(removed.type) }}
                                                </span>
                                            </div>
                                            <v-chip v-if="qgcData.removedRecords.length > 1" small dark color="rgba(255,255,255,0.25)" label>
                                                {{ idx + 1 }} de {{ qgcData.removedRecords.length }}
                                            </v-chip>
                                        </div>
                                        <!-- Conteúdo -->
                                        <div style="padding: 20px; background: #ffffff;">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <div style="color: #212121; font-size: 14px;">
                                                        <v-icon small color="grey darken-1" class="mr-1">mdi-calendar-remove</v-icon>
                                                        <strong>Removido em:</strong> {{ removed.removed_at | formatDate }}
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" sm="6" v-if="removed.removed_by">
                                                    <div style="color: #212121; font-size: 14px;">
                                                        <v-icon small color="grey darken-1" class="mr-1">mdi-account-outline</v-icon>
                                                        <strong>Removido por:</strong> {{ removed.removed_by }}
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="removed.reason" class="mt-2">
                                                <v-col cols="12">
                                                    <div style="color: #212121; font-size: 14px; margin-bottom: 6px;">
                                                        <v-icon small color="grey darken-1" class="mr-1">mdi-text-box-outline</v-icon>
                                                        <strong>Motivo:</strong>
                                                    </div>
                                                    <div style="background: #f5f5f5; border-left: 4px solid #f44336; border-radius: 4px; padding: 12px 16px; color: #212121; font-size: 14px; line-height: 1.6;">
                                                        {{ removed.reason }}
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <!-- Dados anteriores -->
                                            <v-row class="mt-3">
                                                <v-col cols="12">
                                                    <div style="color: #757575; font-size: 13px; margin-bottom: 8px; font-weight: 600;">
                                                        <v-icon x-small class="mr-1">mdi-history</v-icon>
                                                        Dados anteriores:
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <span class="main-text">{{ removed.name || 'N/A' }}</span>
                                                    <div class="caption-text2">NOME</div>
                                                </v-col>
                                                <v-col cols="12" sm="4">
                                                    <span class="main-text">{{ formatQgcRegistration(removed.registration) }}</span>
                                                    <div class="caption-text2">CPF/CNPJ</div>
                                                </v-col>
                                                <v-col cols="12" sm="4">
                                                    <span class="main-text">{{ formatQgcCreditorType(removed.type) }}</span>
                                                    <div class="caption-text2">CLASSE</div>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="4">
                                                    <span class="main-text">R$ {{ formatQgcCurrency(removed.amount) }}</span>
                                                    <div class="caption-text2">VALOR DO CREDITO</div>
                                                </v-col>
                                                <v-col cols="12" sm="4">
                                                    <span class="main-text">{{ formatQgcCurrencyType(removed.currency) }}</span>
                                                    <div class="caption-text2">MOEDA</div>
                                                </v-col>
                                                <!-- <v-col cols="12" sm="4">
                                                    <span class="main-text">{{ formatQgcVersion(removed.version) }}</span>
                                                    <div class="caption-text2">VERSAO QGC</div>
                                                </v-col> -->
                                            </v-row>
                                        </div>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- HISTÓRICO DE EDIÇÕES -->
                        <template v-if="!qgcData.loading && qgcData.status === 'found' && qgcData.auditHistory.length > 0">
                            <v-row class="mt-4">
                                <v-col cols="12">
                                    <div class="subtitle-2 font-weight-bold mb-3" style="color: #333;">
                                        <v-icon small class="mr-1">mdi-history</v-icon>
                                        Histórico de alterações
                                        <v-chip small color="info" label text-color="white" class="ml-2">
                                            {{ qgcData.auditHistory.length }} {{ qgcData.auditHistory.length === 1 ? 'registro' : 'registros' }}
                                        </v-chip>
                                    </div>

                                    <v-expansion-panels accordion flat>
                                        <v-expansion-panel
                                            v-for="(audit, index) in qgcData.auditHistory"
                                            :key="'audit-' + index"
                                            class="mb-2"
                                            style="border: 1px solid #e0e0e0; border-radius: 8px !important;">
                                            <v-expansion-panel-header>
                                                <div class="d-flex align-center">
                                                    <v-icon small color="primary" class="mr-2">mdi-pencil-outline</v-icon>
                                                    <strong class="mr-3">Edição #{{ qgcData.auditHistory.length - index }}</strong>
                                                    <v-chip x-small label color="blue-grey lighten-4" class="mr-3">
                                                        {{ formatQgcCreditorType(getAuditCreditorType(audit)) }}
                                                    </v-chip>
                                                    <span class="grey--text text--darken-1" style="font-size: 13px;">
                                                        {{ audit.created_at | formatDate }}
                                                        <span v-if="audit.admin_name"> — por <strong>{{ audit.admin_name }}</strong></span>
                                                    </span>
                                                </div>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-simple-table dense>
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 25%;">Campo</th>
                                                            <th style="width: 37%;">Valor Anterior</th>
                                                            <th style="width: 38%;">Novo Valor</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="field in getQgcChangedFields(audit)" :key="field.key">
                                                            <td class="font-weight-medium">{{ field.label }}</td>
                                                            <td>
                                                                <span v-if="field.changed" class="red--text text--lighten-1">
                                                                    <del>{{ field.oldValue }}</del>
                                                                </span>
                                                                <span v-else class="grey--text">{{ field.oldValue }}</span>
                                                            </td>
                                                            <td>
                                                                <v-chip v-if="field.changed" small color="green lighten-4" text-color="green darken-3" label class="font-weight-bold">
                                                                    <v-icon x-small left>mdi-arrow-right-bold</v-icon>
                                                                    {{ field.newValue }}
                                                                </v-chip>
                                                                <span v-else class="grey--text">{{ field.newValue }}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- Sem histórico (quando tem registros mas sem edições) -->
                        <template v-if="!qgcData.loading && qgcData.status === 'found' && qgcData.auditHistory.length === 0">
                            <v-row class="mt-2">
                                <v-col cols="12">
                                    <v-alert type="info" text dense class="mb-0">
                                        Nenhuma alteracao registrada para este credor no QGC Consolidado.
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </template>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Dialog solicitação de documentos -->
        <v-dialog v-model="dialogRequestDoc" max-width="700px">
            <v-card>

                <v-card-title class="text-center text--darken-2"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Seleção de Documentos
                </v-card-title>
                <v-card-text>
                    <v-container class="pa-0">
                        <br>
                        <p>
                            Selecione o(s) documento(s) que deseja solicitar ao credor <strong>{{ dataset.data &&
                                dataset.data.name
                                }}</strong>.
                        </p>
                        <v-checkbox v-for="doc in creditorIdDocTypes" :key="doc.id" :label="doc.name" :value="doc.id"
                            v-model="selectedRequestDocs" class="mt-0 mb-0"></v-checkbox>
                        <br>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :loading="requestDocLoading" type="button" elevation="0" color="primary"
                        @click="sendSelectedList">
                        Solicitar
                    </v-btn>
                    <v-btn color="grey" text @click="closeDialogRequestDoc">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal mostrar motivo rejeição representante -->
        <v-dialog v-model="showRejectReasonModal" max-width="700px">
            <v-card>
                <v-card-title class="table-card-title">Motivo da rejeição</v-card-title>
                <v-card-text>
                    {{ dataset.data.representative_reject_reason }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="showRejectReasonModal = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para entrar com o texto motivo rejeição representante-->
        <v-dialog v-model="showRejectDialog" max-width="600px">
            <v-card>
                <v-card-title class="table-card-title">Rejeitar representante</v-card-title>

                <v-card-text>
                    <p>Informe o motivo da rejeição</p>
                    <v-textarea v-model="rejectReason" label="Motivo" auto-grow :rows="2" counter maxlength="255"
                        outlined clearable />
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="onCancelReject">Cancelar</v-btn>
                    <v-btn color="primary" :disabled="!rejectReason.trim()" @click="onConfirmReject">
                        Rejeitar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <!-- Modal dados cadastrais / endereço -->
        <v-dialog v-model="dialogAddress" max-width="750px">
            <v-card>
                <v-card-title style="border-bottom: 3px solid #1976d2; padding-bottom: 12px;">
                    <v-icon color="primary" class="mr-2">mdi-map-marker-outline</v-icon>
                    Dados Cadastrais
                    <v-spacer />
                    <v-btn icon @click="dialogAddress = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-5">
                    

                    <!-- Modal Endereço credor-->
                    <div class="font-weight-bold mb-3" style="color: #333; font-size: 14px;">
                        <v-icon small class="mr-1" color="primary">mdi-home-outline</v-icon>
                        Endereço
                    </div>
                    <v-sheet class="pa-4" elevation="0" style="border: 1px solid #e0e0e0; border-radius: 8px;">
                        <template v-if="dataset.data.address_street || dataset.data.address_zipcode">
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">CEP:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_postal_code || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">Logradouro:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_street || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <strong style="color: #212121;">Número:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_number || 'N/A' }}</div>
                                </v-col>
                            </v-row>
                            
                            <v-row>
                                
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">Complemento:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_complement || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">Bairro:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_neighborhood || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">Cidade:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_city || 'N/A' }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                               
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">Estado:</strong>
                                    <div style="color: #424242;">{{ dataset.data.address_state || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <strong style="color: #212121;">País:</strong>
                                    <div style="color: #424242;">{{ dataset.data.nationality || 'N/A' }}</div>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-else>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-icon color="grey" class="mb-1">mdi-map-marker-off-outline</v-icon>
                                    <div class="grey--text">Nenhum endereço cadastrado.</div>
                                </v-col>
                            </v-row>
                        </template>
                    </v-sheet>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="dialogAddress = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
//import string from "@/common/util/string"
import { cpf, cnpj } from 'cpf-cnpj-validator'
import sanitizers from '@/common/util/string'

import businessDocTypes from "@/common/data/business-doc-types.data"
import creditorEmailDocTypes from "@/common/data/creditor-email-doc-types.data"
import currencyTypes from "@/common/data/currency-types.data"
import creditorTypes from "@/common/data/creditor-types.data"
import qgcVersions from '@/common/data/qgc-versions.data.js';

import userTypes from "@/common/data/user-types.data"

import axios from "axios"

export default {
    name: "UserDetails",

    filters: {
        formatDate(value) {
            if (!value || value === '0000-00-00 00:00:00') return 'N/A';
            var d = new Date(value);
            var day = String(d.getDate()).padStart(2, '0');
            var month = String(d.getMonth() + 1).padStart(2, '0');
            var year = d.getFullYear();
            var hours = String(d.getHours()).padStart(2, '0');
            var minutes = String(d.getMinutes()).padStart(2, '0');
            return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
        },
    },

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        dialogAddress: false,
        showRejectReasonModal: false,
        showRejectDialog: false,
        pendingStatus: null,
        pendingRepresentativeId: null,
        rejectReason: '',
        requestDocLoading: false,
        businessDocTypes: businessDocTypes,
        creditorEmailDocTypes: creditorEmailDocTypes,
        creditorIdDocTypes: [{ id: 1, name: 'Documento de identificação'}, { id: 2, name: 'Procuração' }],
        dialogRequestDoc: false,
        selectedRequestDocs: [],
        dataset: {
            userTypes: userTypes,
            currencyTypes: currencyTypes,
            creditorTypes: creditorTypes,
            versionOptions: qgcVersions,
            breadcrumbItems: [],
            states: states,
            data: {
                registration: "",
                invalid_doc_id: false,
            },
            events: []
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        checkIfTempestiva: false,
        userLawyerData: null,
        procuratorsList: [],
        qgcData: {
            loading: false,
            status: 'not_found', // 'found', 'not_found'
            records: [],         // registros ativos
            removedRecords: [],  // registros removidos
            auditHistory: [],
        },
        certificateDownloads: {
            loading: false,
            items: [],
            actorTypes: [
                { id: 1, name: 'Credor' },
                { id: 2, name: 'Procurador' },
                { id: 3, name: 'Administrador' },
            ],
            headers: [
                { text: 'Quem baixou', value: 'downloaded_by_type' },
                { text: 'Nome', value: 'downloaded_by_name' },
                { text: 'Origem', value: 'source' },
                { text: 'IP', value: 'ip_address' },
                { text: 'Data', value: 'created_at' },
            ],
        },
        // representativesList: [],
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();
    },

    computed: {
        fileRules() {
            const rules = [];
            if (!this.dataset.data.documentUrl) {

                rules.push(this.$rules.required);
            }
            rules.push(this.$rules.fileSize(150));
            return rules;
        },

        shortRejectReason() {
            const reason = this.dataset.data.representative_reject_reason || ''
            
            return reason.length > 50 ? reason.slice(0, 50) + '…' : reason
        },

    },

    methods: {
        goBack() {
            this.$router.replace("/credores");
        },

        getMessageByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `Credor acessou o sistema no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'approve-user':
                    result = `Credor foi incluído na lista no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'accept-value':
                    result = `Credor aceitou o crédito no valor de R$ ${this.dataset.data.requested_value} no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'verify-account':
                    result = `Credor verificou a conta no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'register-user':
                    result = `Credor criou a conta no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'create-event':
                    result = `Credor registrou uma divergência no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                default:
                    break;
            }

            return result;
        },

        getTitleByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `acesso`;
                    break;

                case 'approve-user':
                    result = `LISTA`;
                    break;

                case 'accept-value':
                    result = `CRÉDITO`;
                    break;

                case 'verify-account':
                    result = `verificação`;
                    break;

                case 'register-user':
                    result = `cadastro`;
                    break;

                case 'create-event':
                    result = `divergência`;
                    break;

                default:
                    break;
            }

            return result;
        },

        formatRepRegistration(rep) {
            if (!rep || !rep.registration) return ''

            const value = String(rep.registration).replace(/\D/g, '')

            if (this.dataset.data.is_foreign) {
            return value
            }

            if (value.length === 11) {
            return cpf.format(value)
            }

            return value
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            await this.load();
            await this.loadCertificateDownloads();
            await this.loadEvents();
            await this.loadQgcData();
            //await this.loadUserInfo()
            this.checkIfTempestiva = this.dataset.data.timely_date !== '0000-00-00 00:00:00';
        },

        async loadCertificateDownloads() {
            const registration = String(this.dataset.data.registration || '').replace(/\D/g, '')
            if (!registration) return

            this.certificateDownloads.loading = true

            try {
                const result = await axios.get(`/api/admin/issued-credit-certificates/creditor/${registration}/downloads`)
                this.certificateDownloads.items = result.data.content || []
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.certificateDownloads.loading = false
            }
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = "Detalhes do credor";
        },

        getRequestDoc() {
            return JSON.parse(this.dataset.data.userEvents[0].requested_doc || '[]')
        },

        openRequestDoc() {

            this.dialogRequestDoc = true;
        },

        closeDialogRequestDoc() {
            this.selectedRequestDocs = [];
            this.dialogRequestDoc = false;
        },

        async sendSelectedList() {

            const payload = this.requestedDocsPayload();

            if (!payload) { 
                return;
            }

            if (!this.selectedRequestDocs || this.selectedRequestDocs.length === 0) {

                this.$dialog.notify.error(`Nenhum documento seleciondo!`, { position: "top-right", timeout: 3000 });

                return
            }

            const userEvents = (this.dataset && this.dataset.data && Array.isArray(this.dataset.data.userEvents))
                ? this.dataset.data.userEvents
                : [];


           this.requestDocLoading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/creditor-doc-request/${userEvents[0].id}`, { docList: payload });

                await this.load()

                this.$dialog.notify.info("Solicitação de documento(s) enviada com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {

                this.requestDocLoading = false;
                this.selectedRequestDocs = [],
                this.dialogRequestDoc = false;
            }

        },

        requestedDocsPayload() {
            const payload = [];
            let hasError = false;

            if (this.selectedRequestDocs.length > 0) {
                const updatedDocs = this.selectedRequestDocs.map(docId => ({
                    id: docId,
                    uploaded: false,
                }));

                const userEvents = (this.dataset && this.dataset.data && Array.isArray(this.dataset.data.userEvents))
                    ? this.dataset.data.userEvents
                    : [];

                if (userEvents.length > 0) {
                    let requestedDoc = userEvents[0].requested_doc;

                    if (!requestedDoc || requestedDoc === 0 || requestedDoc.length === 0) {
                        payload.push({
                            user_event_id: userEvents[0].id,
                            docs: updatedDocs,
                        });
                       
                    } else {
                        requestedDoc = JSON.parse(requestedDoc);

                        if (Array.isArray(requestedDoc)) {
                            let eventWithUserEventId = requestedDoc.find(event => event.user_event_id !== undefined);

                            if (eventWithUserEventId) {
                                if (!Array.isArray(eventWithUserEventId.docs)) {
                                    eventWithUserEventId.docs = [];
                                }

                                for (const updatedDoc of updatedDocs) {
                                    const existingDocIndex = eventWithUserEventId.docs.findIndex(doc => doc.id === updatedDoc.id);

                                    if (existingDocIndex !== -1) {
                                        const existingDoc = eventWithUserEventId.docs[existingDocIndex];

                                        if (!existingDoc.uploaded) {

                                            if (updatedDoc.id === 1) {
                                                this.$dialog.notify.error("Já existe uma solicitação de documento de identidade.", { position: "top-right", timeout: 3000 });
                                            } else if (updatedDoc.id === 2) {
                                                this.$dialog.notify.error("Já existe uma solicitação de documento de procuração.", { position: "top-right", timeout: 3000 });
                                            }
                                            hasError = true;
                                            break;
                                        }

                                        eventWithUserEventId.docs[existingDocIndex] = updatedDoc;
                                    } else {
                                        eventWithUserEventId.docs.push(updatedDoc);
                                    }
                                }

                                if (hasError) {
                                    return null; 
                                }

                            } else {
                                requestedDoc.push({
                                    user_event_id: userEvents[0].id,
                                    docs: updatedDocs,
                                });
                            }

                            payload.push(...requestedDoc);
                        } else {
                            payload.push({
                                user_event_id: userEvents[0].id,
                                docs: updatedDocs,
                            });
                        }
                    }
                }
            }

            return payload;
        },

        lawyerDetails(lawyer) {
            //window.open(#/credores/${user.id}); // nova aba
            console.log("lawyer no detalhe:", lawyer)
            console.log(lawyer.id)
            window.location.href = `#/procuradores/${lawyer.id}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Credores",
                disabled: false,
                to: "/credores",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: "Detalhes do credor",
                disabled: true,
                exact: true,
            });
        },

        formatCpfCnpj(value) {

            if (!value) {
                return ''
            }

            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        formatRegistration() {
            this.dataset.data.registration = this.formatCpfCnpj(this.dataset.data.registration);
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o credor?',
                title: 'Atualizar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;


            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/users/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Credor salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async approveUser() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja aprovar o credor?',
                title: 'Aprovar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Aprovar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const response = await axios.post(`/api/admin/users/approve/${this.$route.params.id}`, {});

                this.$dialog.notify.info("Credor aprovado com sucesso", { position: "top-right", timeout: 2000 });

                this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async verifyAccount() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja verificar a conta?',
                title: 'Verificar conta',
                actions: {
                    false: 'Cancelar',
                    true: 'Verificar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const response = await axios.post(`/api/admin/users/verify-account/${this.$route.params.id}`, {});

                this.$dialog.notify.info("Conta verificada com sucesso", { position: "top-right", timeout: 2000 });

                this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async load() {

            try {
                
                const result = await axios.get(`/api/admin/users/find-accepted-lawyer/${this.$route.params.id}`);

                const rawData = result.data.content;

                const registration = rawData.registration;

                const formattedRegistration = rawData.registration
                    ? rawData.registration.length < 14
                    ? cpf.format(rawData.registration)
                    : cnpj.format(rawData.registration)
                    : rawData.registration;

                const processedData = {
                    ...rawData,
                    registration: formattedRegistration
                };

                this.dataset.data = processedData;

                // if (registration) {
                //     this.dataset.data.registration = registration.length < 14 ? cpf.format(registration) : cnpj.format(registration);
                // }

                if (this.dataset.data.lawyers_user && this.dataset.data.lawyers_user.length > 0) {
                    
                    this.userLawyerData = this.dataset.data.lawyers_user[0];
                    
                } else {
                    
                    this.userLawyerData = null;
                }

                if (this.dataset.data && this.dataset.data.lawyers_list){
                    
                    let list = this.dataset.data.lawyers_list
                    
                    if (typeof list === 'string') {
                        list = JSON.parse(list)
                    }

                    this.procuratorsList = list.map((item, index) => ({
                        localId: Date.now() + index,
                        name: item.name || '',
                        oab: item.oab || ''
                    }))

                }


            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadEvents() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/user-logs/user/${this.$route.params.id}`);

                this.dataset.events = result.data.content;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadUserInfo() {
            try {
                const result = await axios.get('/api/users/info');
                this.user = result.data.content;

                console.log("user info: " + this.user)

                if (this.user.lawyers_user && this.user.lawyers_user.length > 0) {
                    //console.log("Dados de lawyers_user recebidos:", this.user.lawyers_user);
                    this.userLawyerData = this.user.lawyers_user[0];
                    //console.log("Dados de lawyer dentro de lawyers_user:", this.userLawyerData.lawyer);
                } else {
                    //console.log("Nenhum procurador associado encontrado.");
                    this.userLawyerData = null;
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        onFileSelected(event) {
            this.dataset.data.file = event;
        },

        onContractSelected(event) {
            this.dataset.data.social_contract = event;
        },


        buildPayload() {
            const formData = new FormData();

            formData.append('name', this.dataset.data.name);
            formData.append('email', this.dataset.data.email);
            formData.append('phone_number', this.dataset.data.phone_number);
            formData.append('registration', sanitizers.sanitizeCpfCnpj(this.dataset.data.registration));
            formData.append('timely_date', this.dataset.data.timely_date);
            formData.append('invalid_doc_id', this.dataset.data.invalid_doc_id);

            if (this.dataset.data.file) {
                formData.append('file', this.dataset.data.file);
            }

            if (this.dataset.data.social_contract) {
                formData.append('social_contract', this.dataset.data.social_contract);
            }

            return formData;
        },

        handleTempestivaChange() {
            this.dataset.data.timely_date = this.checkIfTempestiva
                ? new Date().toISOString().slice(0, 19).replace('T', ' ')
                : '0000-00-00 00:00:00';
        },

        async updateUser() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do credor?',
                title: 'Atualizar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/users/update/${this.$route.params.id}`, payload, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.$dialog.notify.info("Credor atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async blockUser() {

            const isBlocked = this.dataset.data.status === 3;
            const text = isBlocked ? 'Deseja desbloquear o credor?' : 'Deseja bloquear o credor?';
            const title = isBlocked ? 'Desbloquear credor' : 'Bloquear credor';
            const actionTrue = isBlocked ? 'Desbloquear' : 'Bloquear';
            const payload = isBlocked ? 0 : 3;

            const proceedAction = await this.$dialog.confirm({
                text,
                title,
                actions: {
                    false: 'Cancelar',
                    true: actionTrue,
                },
            });

            if (!proceedAction) return;

            try {
                const response = await axios.patch(`/api/admin/users/update/${this.$route.params.id}`, { status: payload });

                this.$dialog.notify.info(`Credor ${isBlocked ? 'desbloqueado' : 'bloqueado'} com sucesso!`, { position: "top-right", timeout: 3000 });

                this.goBack()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async restoreApprovedValue() {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja <b>RESTAURAR</b> a aprovação de crédito deste credor?',
                title: 'Restaurar aprovação',
                actions: {
                    false: 'Cancelar',
                    true: 'Restaurar'
                }
            })

            if (!proceedAction) return;

            const id = this.dataset.data.creditorData.id

            try {
                const response = await axios.patch(`api/admin/users-creditors/restore-approved-amount/${this.dataset.data.creditorData.id}`);

                this.$dialog.notify.info(`Aprovação de crédito restaurada com sucesso!`, { position: "top-right", timeout: 3000 });

                this.goBack()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        onCancelReject() {
            this.showRejectDialog = false;
            this.$dialog.notify.warning('Rejeição cancelada!', { position: 'top-right' });
        },

        async onConfirmReject() {
            if (!this.rejectReason.trim()) return;

            this.showRejectDialog = false;

            return this.handleStatusChange(
                this.pendingRepresentativeId,
                2,
                this.rejectReason.trim()
            );
        },

        async changeRepresentativeStatus(id, status) {
            if (status === 1) {
                return this.handleStatusChange(id, 1);
            }

            this.pendingRepresentativeId = id;
            this.pendingStatus = 2;
            this.rejectReason = '';
            this.showRejectDialog = true;
        },

        async handleStatusChange(id, status, reason = null) {
            
            const isApprove = status === 1;

            const proceed = await this.$dialog.confirm({
                title: isApprove ? 'Aprovar representante' : 'Confirmar rejeição',
                text: isApprove
                    ? 'Deseja aprovar o representante?'
                    : 'Deseja realmente rejeitar o representante?',
                actions: {
                    false: 'Cancelar',
                    true: isApprove ? 'Aprovar' : 'Rejeitar'
                }
            });

            if (!proceed) {
                if (!isApprove) {
                    this.$dialog.notify.warning('Rejeição abortada!', { position: 'top-right' });
                }
                return;
            }

            try {
                await axios.patch(
                    `/api/admin/users/update-representative-status/${id}`,
                    {
                        representative_status: status,
                        ...(status === 2 ? { rejection_reason: reason.trim() } : {}),
                        userId: this.dataset.data.id
                    }
                );

                this.$dialog.notify.info(
                    isApprove
                        ? 'Representante aprovado com sucesso!'
                        : 'Representante rejeitado com sucesso!',
                    { position: 'top-right', timeout: 3000 }
                );

                this.loadData();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                });
            }
        },

        getRepStatusText(status) {
            switch (status) {
            case 0: return 'Pendente de análise';
            case 1: return 'Representante aprovado';
            case 2: return 'Representante rejeitado';
            default: return 'Status não definido';
            }
        },

        getRepStatusColor(status) {
            switch (status) {
            case 0: return 'warning';
            case 1: return 'success';
            case 2: return 'error';
            default: return 'info';
            }
        },

        // ============================================
        // MÉTODOS QGC V3
        // ============================================

        formatQgcRegistration(registration) {
            if (!registration) return 'N/A';
            const value = String(registration).replace(/\D/g, '');
            if (value.length === 11) return cpf.format(value);
            if (value.length === 14) return cnpj.format(value);
            return value;
        },

        formatQgcCurrency(value) {
            if (!value && value !== 0) return '0,00';
            return Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },

        async loadQgcData() {
            this.qgcData.loading = true;
            this.qgcData.records = [];
            this.qgcData.removedRecords = [];
            this.qgcData.auditHistory = [];

            try {
                const registration = this.dataset.data.registration
                    ? String(this.dataset.data.registration).replace(/\D/g, '')
                    : null;

                if (!registration) {
                    this.qgcData.status = 'not_found';
                    return;
                }

                const result = await axios.get('/api/admin/users-creditors-claim/find-by-registration/' + registration);

                const data = result.data.content;

                if (!data || !data.records || data.records.length === 0) {
                    this.qgcData.status = 'not_found';
                    return;
                }

                this.qgcData.status = 'found';

                // Separa registros ativos e removidos
                data.records.forEach(function(record) {
                    if (record.removed_at && record.removed_at !== '0000-00-00 00:00:00') {
                        this.qgcData.removedRecords.push({
                            id: record.id,
                            name: record.name || '',
                            registration: record.registration || '',
                            type: record.type || '',
                            amount: record.amount || 0,
                            currency: record.currency || '',
                            version: record.version || '',
                            removed_at: record.removed_at,
                            removed_by: record.removed_by_name || null,
                            reason: record.removed_reason || null,
                        });
                    } else {
                        this.qgcData.records.push(record);
                    }
                }.bind(this));

                // Carrega histórico de edições (todos os registros)
                if (data.audit_history && Array.isArray(data.audit_history)) {
                    this.qgcData.auditHistory = data.audit_history.filter(function(audit) {
                        var newData = audit.new_data;
                        if (typeof newData === 'string') {
                            try { newData = JSON.parse(newData); } catch (e) { newData = null; }
                        }
                        var oldData = audit.old_data;
                        if (typeof oldData === 'string') {
                            try { oldData = JSON.parse(oldData); } catch (e) { oldData = null; }
                        }
                        // Só mostra se tiver ambos (edição real)
                        return oldData && newData && Object.keys(newData).length > 0;
                    });
                } else {
                    this.qgcData.auditHistory = [];
                }

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    this.qgcData.status = 'not_found';
                } else {
                    this.$dialog.notify.error('Erro ao consultar dados do QGC Consolidado.', {
                        position: 'top-right',
                        timeout: 3000
                    });
                    this.qgcData.status = 'not_found';
                }
            } finally {
                this.qgcData.loading = false;
            }
        },

        getQgcChangedFields(audit) {
            var self = this;
            var fields = [];
            var fieldLabels = {
                name: 'Nome',
                email: 'Email',
                registration: 'CPF/CNPJ',
                type: 'Classe',
                currency: 'Moeda',
                amount: 'Valor',
                //version: 'Versao QGC',
            };

            var oldData = audit.old_data;
            var newData = audit.new_data;

            // Parse se vier como string JSON
            if (typeof oldData === 'string') {
                try { oldData = JSON.parse(oldData); } catch (e) { oldData = {}; }
            }
            if (typeof newData === 'string') {
                try { newData = JSON.parse(newData); } catch (e) { newData = {}; }
            }

            if (!oldData) oldData = {};
            if (!newData) newData = {};

            // Coleta todas as chaves de ambos os objetos
            var allKeys = {};
            Object.keys(oldData).forEach(function(k) { allKeys[k] = true; });
            Object.keys(newData).forEach(function(k) { allKeys[k] = true; });

            for (var key in allKeys) {
                if (!fieldLabels[key]) continue;

                var oldRaw = oldData[key] !== undefined ? oldData[key] : null;
                var newRaw = newData[key] !== undefined ? newData[key] : null;
                var changed = String(oldRaw) !== String(newRaw);

                var oldValue = oldRaw;
                var newValue = newRaw;

                // Formata valores especiais
                if (key === 'amount') {
                    oldValue = oldRaw != null ? 'R$ ' + self.formatQgcCurrency(oldRaw) : 'N/A';
                    newValue = newRaw != null ? 'R$ ' + self.formatQgcCurrency(newRaw) : 'N/A';
                } else if (key === 'registration') {
                    oldValue = self.formatQgcRegistration(oldRaw);
                    newValue = newRaw ? self.formatQgcRegistration(newRaw) : 'N/A';
                } else if (key === 'currency') {
                    oldValue = self.formatQgcCurrencyType(oldRaw);
                    newValue = newRaw != null ? self.formatQgcCurrencyType(newRaw) : 'N/A';
                } else if (key === 'type') {
                    oldValue = self.formatQgcCreditorType(oldRaw);
                    newValue = newRaw != null ? self.formatQgcCreditorType(newRaw) : 'N/A';
                } else if (key === 'version') {
                    oldValue = self.formatQgcVersion(oldRaw);
                    newValue = newRaw != null ? self.formatQgcVersion(newRaw) : 'N/A';
                }

                fields.push({
                    key: key,
                    label: fieldLabels[key],
                    oldValue: oldValue != null ? oldValue : 'N/A',
                    newValue: newValue != null ? newValue : 'N/A',
                    changed: changed,
                });
            }

            return fields;
        },


        formatQgcCurrencyType(value) {
            if (!value && value !== 0) return 'N/A';
            var found = this.dataset.currencyTypes.find(function(item) {
                return item.id == value;
            });
            return found ? found.name : value;
        },

        formatQgcCreditorType(value) {
            if (!value && value !== 0) return 'N/A';
            var found = this.dataset.creditorTypes.find(function(item) {
                return item.id == value;
            });
            return found ? found.name : value;
        },

        formatQgcVersion(value) {
            if (!value && value !== 0) return 'N/A';
            var found = this.dataset.versionOptions.find(function(item) {
                return item.id == value;
            });
            return found ? found.label : value;
        },

        getAuditCreditorType(audit) {
            if (audit.creditor_type) return audit.creditor_type;
            var newData = audit.new_data;
            if (typeof newData === 'string') {
                try { newData = JSON.parse(newData); } catch (e) { return ''; }
            }
            return newData && newData.type ? newData.type : '';
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.section-info-title {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.main-text {
  font-size: 16px;
  color: #000;
}

.caption-text2 {
  font-size: 12px;
  font-weight: bold;
  color: #444;
  margin-top: -5px;
}

.procurator-panel {
  width: 80% !important;           
  margin: 4px auto !important;     
  border-radius: 6px;  
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  
}

.icon-toolbar {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 6px 16px;
}
</style>
